import { ref } from 'vue'

import { defineStore } from 'pinia'

export const useMaintenanceStore = defineStore('maintenance', () => {
  const isMaintenanceMode = ref(false)

  const setMaintenanceMode = value => {
    isMaintenanceMode.value = value
  }

  return {
    isMaintenanceMode,
    setMaintenanceMode
  }
})
